<template>
    <div class="space-y-6">
        <FormYesNo
            label="Do all travelers need to be on the same flight?"
            name="same_flight_required"
            v-model="form.same_flight_required"
            :errors="errors"
            required
        />

        <FormYesNo
            label="Are there any countries that you cannot travel through for any reason?"
            name="has_travel_restrictions"
            v-model="form.has_travel_restrictions"
            :errors="errors"
            required
        />

        <UiInput
            v-if="form.has_travel_restrictions"
            id="travel_restrictions"
            name="travel_restrictions"
            label="Which countries can you not travel through?"
            v-model:inputValue="form.travel_restrictions"
            :errors="errors"
            :options="{ required: true }"
        />

        <div>
            <label class="block text-sm font-medium text-slate-700 dark:text-slate-200 mb-2">
                What is your preferred cabin?
                <span class="text-red-500" aria-hidden="true">*</span>
            </label>
            <div class="flex flex-wrap gap-2">
                <button
                    v-for="cabin in cabinOptions"
                    :key="cabin.value"
                    type="button"
                    @click="toggleCabin(cabin.value)"
                    :class="[
                        'px-4 py-2 rounded-lg border text-sm font-medium transition-colors inline-flex items-center gap-2',
                        form.preferred_cabins.includes(cabin.value)
                            ? 'border-orange-500 bg-orange-50 text-orange-700 dark:bg-orange-500/20 dark:text-orange-300 dark:border-orange-500/60'
                            : 'border-slate-200 bg-white text-slate-600 hover:border-slate-300 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-600 dark:hover:border-slate-500',
                    ]"
                >
                    <Icon
                        v-if="form.preferred_cabins.includes(cabin.value)"
                        icon="check"
                        :width="14"
                        :height="14"
                    />
                    {{ cabin.label }}
                </button>
            </div>
            <p class="mt-1.5 text-xs text-slate-500 dark:text-slate-400">
                Select every cabin you'd be happy flying.
            </p>
            <p v-if="cabinError" class="mt-1.5 text-sm text-red-600 dark:text-red-400">
                {{ cabinError }}
            </p>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import Icon from '@/components/ui/icon/icon.vue';
import UiInput from '@/components/ui/inputs/ui-input.vue';
import FormYesNo from '@/components/award-bookings/request-form/form-yes-no.vue';

const props = defineProps({
    form: { type: Object, required: true },
    errors: { type: Object, default: null },
    cabinOptions: { type: Array, required: true },
});

const toggleCabin = (value) => {
    const index = props.form.preferred_cabins.indexOf(value);
    if (index === -1) {
        props.form.preferred_cabins.push(value);
    } else {
        props.form.preferred_cabins.splice(index, 1);
    }
};

const cabinError = computed(() => {
    const fieldErrors =
        props.errors?.preferred_cabins || props.errors?.['preferred_cabins.0'];
    return Array.isArray(fieldErrors) ? fieldErrors[0] : null;
});
</script>
